import {
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonPage,
  IonRow,
  IonTitle,
  IonToolbar,
  useIonViewDidEnter,
  useIonViewWillLeave,
} from "@ionic/react";
import { useMemo } from "react";
import { useEffect } from "react";
import { useState } from "react";
import Card from "../components/Card";
import ThumbVideoContext from "../lib/ThumbVideoContext";
import "../css/globals.css";
import projects from "../lib/projects";
import { useTranslation } from "react-i18next";

const Home: React.FC = () => {
  const [viewDidEnter, setViewDidEnter] = useState(false);
  const [videos, setVideos] = useState<HTMLVideoElement[]>([]);
  const value = useMemo(() => ({ videos, setVideos }), [videos]);
  const { t } = useTranslation();

  const playVideos = () => {
    if (viewDidEnter) {
      if (videos.length > 0) {
        setTimeout(() => {
          videos[0].play();
        }, 350);
      }
      videos.forEach(
        (video, i) =>
          (video.onended = () => {
            if (i < videos.length - 1) {
              videos[i + 1].play();
            } else if (videos.length > 0) {
              videos[0].play();
            }
          })
      );
    }
  };
  useIonViewDidEnter(() => {
    setTimeout(() => {
      setViewDidEnter(true);
    }, 500);
  });
  useIonViewWillLeave(() => {
    setViewDidEnter(false);
  });

  useEffect(() => {
    playVideos();
  }, [viewDidEnter, videos]);
  return (
    <ThumbVideoContext.Provider value={value}>
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonTitle>{t(`Code Artist`)}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <IonHeader collapse="condense">
            <IonToolbar>
              <IonTitle size="large">{t(`Code Artist`)}</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonGrid className="max-w-7xl">
            <IonRow>
              {projects.map((project) => (
                <IonCol key={project.href} size="12" sizeMd="6" sizeLg="4">
                  <Card {...project} />
                </IonCol>
              ))}
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonPage>
    </ThumbVideoContext.Provider>
  );
};

export default Home;
